// react
import { useContext } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// context
import { ContextIfrReconciliation } from '../Ifr.context';
import { ContextIfr } from '../../Project.context';

// mui
import { Container, Grid } from '@mui/material';

// ui
import { TableSheet } from '../../../../ui/TableSheet/TableSheet';

// pages
import { GridColDefIfr } from '../Ifr';

export const Reconciliation = () => {
	// hooks
	const { t } = useTranslation();

	// context
	const { ifr, ifrTables, setIfrPayload } = useContext(ContextIfr);
	const { setValues } = useContext(ContextIfrReconciliation);

	// vars
	const reconciliation = ifrTables?.reconciliation;
	const columns = reconciliation?.columns || [];
	const rows = reconciliation?.rows || [];
	const palette = reconciliation?.palette || 'purple';

	return (
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<Container maxWidth={false}>
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<TableSheet
								columns={columns}
								isExpandable={false}
								label={t('reconciliation')}
								onDataChange={(row, field, value) => {
									// update values state
									setValues((valuesOld) => {
										const valuesNew = { ...valuesOld };
										if (!valuesNew[row.id as string]) {
											valuesNew[row.id as string] = {};
										}
										if (value !== undefined) {
											valuesNew[row.id as string][field] = value;
										}
										return valuesNew;
									});

									// update payload
									setIfrPayload((ifrPayloadOld) => {
										const ifrPayloadNew = { ...ifrPayloadOld };
										const column = columns.find((c) => c.field === field);
										const loanId = (column as GridColDefIfr)?.loan?.id;

										if (value !== undefined) {
											// add or update bank balance
											if (row.id === 'bank-balance') {
												// append bankBalances property if it does not exist
												if (!('bankBalances' in ifrPayloadNew)) {
													ifrPayloadNew.bankBalances = [];
												}

												// find existing balance
												const existingBalance = ifrPayloadNew?.bankBalances?.find(
													(b) => b.loan === loanId
												);
												if (existingBalance) {
													existingBalance.amount = value;
												} else if (ifr && loanId) {
													ifrPayloadNew?.bankBalances?.push({
														amount: value,
														currency: ifr.currency,
														loan: loanId,
													});
												}

												// Remove bankBalances with zero amount
												ifrPayloadNew.bankBalances = ifrPayloadNew.bankBalances?.filter(
													(b) => b.amount !== 0
												);
											} else {
												// append reconciliationItems property if it does not exist
												if (!('reconciliationItems' in ifrPayloadNew)) {
													ifrPayloadNew.reconciliationItems = [];
												}

												// find existing reconciliation item
												const existingReconItem = ifrPayloadNew?.reconciliationItems?.find(
													(r) =>
														r.reconciliationItem === row.reconciliationItem && r.loan === loanId
												);

												if (existingReconItem) {
													existingReconItem.amount = value;
												} else if (ifr && loanId) {
													ifrPayloadNew?.reconciliationItems?.push({
														amount: value,
														currency: ifr.currency,
														loan: loanId,
														reconciliationItem: row.reconciliationItem,
													});
												}

												// Remove reconciliationItems with zero amount
												ifrPayloadNew.reconciliationItems =
													ifrPayloadNew.reconciliationItems?.filter((r) => r.amount !== 0);
											}
										}
										return ifrPayloadNew;
									});
								}}
								palette={palette}
								rows={rows}
							/>
						</Grid>
					</Grid>
				</Container>
			</Grid>
		</Grid>
	);
};
